import * as React from 'react';
import { Box, CircularProgress } from '@mui/material';

export default function Loader() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        width: 52,
        height: 52,
        mx: 'auto',
      }}
    >
      <CircularProgress
        size={50}
        thickness={3.2}
        sx={{
          color: '#0492D4',
          animationDuration: '1.1s',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          pointerEvents: 'none',
        }}
      >
        <img
          src="/img/aszento.png?v=2"
          alt="Aszento"
          style={{ width: '22px', height: 'auto', display: 'block' }}
        />
      </Box>
    </Box>
  );
}
